import React from "react";
import { useWallet } from "../../wallet-context";

import Button from '../../components/buttons/Button';
import Layout from '../../components/Layout';


const Home: React.FC = () => {
  const { connectWallet } = useWallet();

  return (
    <Layout>
      <main>
        <section>
          <div className='flex flex-col items-center justify-center min-h-screen text-center layout'>
            <h1 className='text-2xl md:text-4xl'>Connect your wallet</h1>
            <div className="p-12">
              <Button className="connectWallet" onClick={async () => {
                await connectWallet();
              }}>
                Click here to connect wallet
              </Button>
              {/* <button type="button" onClick={async () => {
                  await connectWallet();
                }}>
                  Click here to connect wallet
                </button> */}
            </div>
          </div>
        </section>
      </main>
    </Layout>


  );
};

export default Home;
